import { FgSelect } from '@/components';
import { ErrorType } from '@/types';
import TomSelect from 'tom-select';
import { FgAutocomplete } from '../fg-autocomplete';

export const autoCompleteValidation = (
  inputs: NodeListOf<FgAutocomplete | FgSelect>,
  items: string[],
  isColorStep: boolean = false,
): { error: ErrorType | null; items: string[] } => {
  const itemData: string[] = [];
  let error = null;
  inputs.forEach(input => {
    let value = input.shadowRoot?.querySelector('input')?.value;
    if (isColorStep && input instanceof FgSelect) {
      const select = input?.shadowRoot?.querySelector('select') as
        | (HTMLSelectElement & { tomselect: TomSelect })
        | null
        | undefined;
      const control = select?.tomselect;
      value = control?.getValue() as string | undefined;
    }

    if (value && value !== '') {
      itemData.push(value);
    }

    if (itemData.length !== inputs.length) {
      error = ErrorType.AUTOCOMPLETE_EMPTY;
      return;
    }

    let invalidInputs = 0;
    error = null;

    itemData.filter(item => {
      if (!items.includes(item)) {
        invalidInputs = invalidInputs + 1;
      }

      if (invalidInputs > 0) {
        error = ErrorType.AUTOCOMPLETE_INVALID;
        return;
      }
      error = null;
    });
  });

  return {
    error: error,
    items: itemData,
  };
};
